import React from 'react'
import spb from '../imgs/spb1.png';





const Special = () => {
    return (
        <section className='section-special'>
        <div className='special'>
            <div className='special-header'>
        <h1 className='header-1 special-header1'>Win a Chance to meet the </h1>
        <h1 className='header-1 special-header2'>natural superheroes</h1>
        </div>
            <img src={spb} className='special__background'/>
            <div className='special__mage'>
       

        </div>
        </div>
        
        

        </section>
    )
}

export default Special
